import {Component, EventEmitter, forwardRef, Input, OnInit, Output} from '@angular/core';
import {AbstractControl, ControlValueAccessor, FormControl, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidatorFn} from '@angular/forms';
import {isNullOrUndefined} from 'util';

export function createSelectedItemsValidator(): ValidatorFn {
    return (fc: FormControl) => {
        if(isNullOrUndefined(fc.value)) {
            return null;
        }
        if(fc.value.length < 1) {
            return {
                atLeastOneItemShouldBeSelected: true,
            }
        }
        return null;
    }
}

export const ITEM_SELECTOR_VALIDATOR = {
    provide: NG_VALIDATORS,
    useExisting: forwardRef(() => ConditionsSelectorComponent),
    multi: true
};

export const ITEM_SELECTOR_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => ConditionsSelectorComponent),
    multi: true
};

@Component({
    selector: 'tfl-conditions-selector',
    template: require('./conditions-selector.component.html'),
    providers: [ITEM_SELECTOR_VALIDATOR, ITEM_SELECTOR_CONTROL_VALUE_ACCESSOR]
})
export class ConditionsSelectorComponent implements OnInit, ControlValueAccessor {

    onChange: EventEmitter<any> = new EventEmitter<any>();
    onTouched: EventEmitter<any> = new EventEmitter<any>();

    writeValue(obj: any): void {
    }

    registerOnChange(fn: any): void {
        this.onChange.subscribe(fn);
    }

    registerOnTouched(fn: any): void {
        this.onTouched.subscribe(fn);
    }

    @Input('available-items') availableItems: ExceptionItem[];
    @Input('selected-items') selectedItems: ExceptionItem[];
    @Input('available-items-name') availableItemsName: string;
    @Input() name: string = 'default';
    @Output() itemSelected = new EventEmitter<ExceptionItem>();
    @Output() itemDeselected = new EventEmitter<ExceptionItem>();

    get selectedDropZoneName() {
        return 'selected-' + this.name;
    }

    get availableDropZoneName() {
        return 'available-' + this.name;
    }

    public deselectAll() {
        this.selectedItems.forEach(it => {
            this.availableItems.push(it);
            this.itemDeselected.emit(it);
        });
    }

    ngOnInit(): void {
        setTimeout(() => this.selectedItems.forEach(it => {
            this.makeItemUnavailable(it.id);
            this.itemSelected.emit(it);
        }));
    }

    getEitherExceptionItemLabelOrName(it: ExceptionItem): string {
        return it.label || it.name;
    }

    private makeItemUnavailable(itemId) {
        let index = this.availableItems.findIndex(ai => ai.id === itemId);
        if (index >= 0) {
            this.availableItems.splice(index, 1);
        }
    }

    selectItem(selectedId: any): void {
        let selected = this.availableItems.find(it => it.id === selectedId);
        if (selected) {
            this.makeItemUnavailable(selectedId);
            this.selectedItems = this.selectedItems.concat(selected);
            this.itemSelected.emit(selected);
            this.onChange.emit(this.selectedItems);
        }
    }

    deselectItem(deselectedId: any): void {
        let deselected = this.selectedItems.find(it => it.id === deselectedId);
        this.selectedItems = this.selectedItems.filter(it => it.id !== deselectedId);
        this.availableItems.push(deselected);
        this.itemDeselected.emit(deselected);
        this.onChange.emit(this.selectedItems);
    }

    onDropSelected(data: any) {
        this.onTouched.emit();
        this.selectItem(data);
    }

    onDropDeselected(data: any) {
        this.onTouched.emit();
        this.deselectItem(data);
    }

    validate(control: AbstractControl): { [key: string]: any } {
        return createSelectedItemsValidator()(control);
    }

}

export interface ExceptionItem {
    id: any;
    name: string;
    label?: string;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/revenue/exceptions/conditions/conditions-selector.component.ts